// extracted by mini-css-extract-plugin
export default {"zoomModal":"S2-z","image":"T2-z","button":"U2-z","isOverlayShown":"V2-z"};